import { notification } from "antd"
import { useMutation, useQuery, useQueryClient } from "react-query"
import { CreateRoleDto, RoleWithPermissions } from "./roles"
import { createRoles, getPermissions, getRoleById, getRolesByTenant, removeRole, updateRolePermissions } from "./rolesApi"

export const useRolesByTenantQuery = (tenantId: number) => {
  return useQuery(['roles'], () => getRolesByTenant(tenantId), { 
    refetchOnWindowFocus: false,
    enabled: !!tenantId
  })
}

export const useGetRoleByIdQuery = (roleId: number) => {
  return useQuery(['role', roleId], () => getRoleById(roleId), { 
    refetchOnWindowFocus: false,
    enabled: !!roleId
  })
}

export const useCreateRolesMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({tenantId, roles }: { tenantId: number, roles: CreateRoleDto[] }) => createRoles(tenantId, roles),
    onSuccess: () => {
      queryClient.invalidateQueries('roles')
      notification.success({ message: 'The roles have been successfully added!' })
    },
    onError: () => {
      notification.error({ message: 'There was an error adding the roles' })
    }
  })
}

export const useUpdateRolePermissionsMutation = () => {
  const queryClient = useQueryClient()

  return useMutation((roleWithPermissions: RoleWithPermissions) => updateRolePermissions(roleWithPermissions), {
    onSuccess: () => {
      queryClient.invalidateQueries('roles')
      notification.success({ message: 'The role permissions have been successfully updated!' })
    },
    onError: () => {
      notification.error({ message: 'There was an error updating the role permissions' })
    }
  })
}

export const useRemoveRoleMutation = () => {
  const queryClient = useQueryClient()

  return useMutation(removeRole, {
    onSuccess: () => {
      queryClient.invalidateQueries('roles')
      notification.success({ message: 'The role has been successfully deleted!' })
    },
    onError: () => {
      notification.error({ message: 'There was an error removing this role' })
    }
  })
}

export const usePermissionsQuery = () => {
  return useQuery(['permissions'], getPermissions, { refetchOnWindowFocus: false })
}